module.exports = "/* Entity Dashboard */\n/* Purple */\n/* Grey */\n/* Teal */\n.metrics {\n  text-align: right;\n  min-height: 110px; }\n"